import IDiscoverPage from '@models/Discover/i-discover-page';
import env from '@lib/envs/env';

export default function getMetaTags(query: any, path: string, discoverPage?: IDiscoverPage) {
  if (discoverPage) {
    let title = `Interior Design Ideas | Havenly`;
    let description = `Discover beautiful designs and decorating inspiration from a variety of rooms designed by Havenly's talented online interior designers.`;

    if (discoverPage.metaDescription) {
      description = discoverPage.metaDescription;
    } else if (discoverPage.name) {
      description = `Browse ${discoverPage.name} designs and interior decorating ideas. Discover beautiful designs and inspiration from a variety of ${discoverPage.name}s designed by Havenly's talented online designers.`;
    }

    if (discoverPage.title) {
      title = `${discoverPage.title} | Havenly`;
    } else if (discoverPage.name) {
      title = `${discoverPage.name} Interior Design Ideas | Havenly`;
    }

    return {
      description,
      title,
      type: 'website',
      image: 'https://s3.amazonaws.com/havenlywebsite/7f16e8d8b48e03ad60b6973c2706a8a2562622688e284ed9bcc744e14689c909.jpg',
      url: `https://${env.DOMAIN_NAME}${path}`,
      keywords: ['interior design inspiration', 'interior designer', 'home decor'],
    };
  }

  const roomTypes = query?.roomType;
  const style = query?.style;

  let title = 'Interior Design Ideas | Havenly';
  let description = `Discover beautiful designs and decorating inspiration from a variety of rooms designed by Havenly's talented online interior designers.`;

  let roomTypesArray: string[] = [];
  let styleArray: string[] = [];

  if (roomTypes) {
    roomTypesArray = roomTypes.split('-_-');
  }

  if (style) {
    styleArray = style.split('-_-');
  }

  if (roomTypes?.length) {
    const {
      singularWords: singularRoomTypes,
      pluralWords: pluralRoomTypes,
    } = getParsedExploreSeoStrings(roomTypesArray);

    title = `${singularRoomTypes} Interior Design Ideas | Havenly`;
    description = `Browse ${singularRoomTypes} designs and interior decorating ideas. Discover beautiful designs and inspiration from a variety of ${pluralRoomTypes} designed by Havenly's talented online designers.`;

    if (style?.length) {
      const {
        singularWords: singularStyles,
      } = getParsedExploreSeoStrings(styleArray);

      title = `${singularStyles} ${title}`;
      description = `Browse ${singularStyles} ${singularRoomTypes} designs and interior decorating ideas. Discover beautiful designs and inspiration from a variety of ${pluralRoomTypes} designed in ${singularStyles} ${styleArray.length > 1 ? 'styles.' : 'style.'}`;
    }
  }

  return {
    description,
    title,
    type: 'website',
    image: 'https://s3.amazonaws.com/havenlywebsite/7f16e8d8b48e03ad60b6973c2706a8a2562622688e284ed9bcc744e14689c909.jpg',
    url: `https://${env.DOMAIN_NAME}${path}`,
    keywords: ['interior design inspiration', 'interior designer', 'home decor'],
  };
}

function getParsedExploreSeoStrings(dirtyArray: string[]) {
  let singularWords = '';
  let pluralWords = '';

  dirtyArray.forEach((value: string, index: number) => {
    const cleanRoomType = value.toLowerCase()
      .replace('-', ' ')
      .split(' ')
      .map((s: string) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ')
      .replace('midcentury', 'Mid-Century');

    if (dirtyArray.length > 2 && index > 0) {
      singularWords += ', ';
      pluralWords += ', ';
    }

    if (dirtyArray.length > 1 && index === dirtyArray.length - 1) {
      singularWords += ' and ';
      pluralWords += ' and ';
    }

    singularWords += cleanRoomType;
    pluralWords += `${cleanRoomType}s`;
  });

  return { singularWords, pluralWords };
}
